import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';

interface Production {
  id: string;
  title: string;
  productionDate: string;
  status: string;
  complianceStatus: string;
  location?: string;
}

export default function Productions() {
  const { data, isLoading } = useQuery({
    queryKey: ['productions'],
    queryFn: () => api.get<{ productions: Production[] }>('/productions'),
  });

  const productions = data?.data.productions || [];

  return (
    <div className="page">
      <div className="page-header">
        <h1>Productions</h1>
        <Link to="/productions/new" className="btn btn-primary">
          New Production
        </Link>
      </div>

      {isLoading ? (
        <div className="loading">Loading productions...</div>
      ) : productions.length === 0 ? (
        <div className="empty-state">
          <p>No productions yet</p>
          <Link to="/productions/new" className="btn btn-primary">
            Create Your First Production
          </Link>
        </div>
      ) : (
        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Date</th>
                <th>Location</th>
                <th>Status</th>
                <th>Compliance</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {productions.map((production) => (
                <tr key={production.id}>
                  <td>
                    <Link to={`/productions/${production.id}`} className="link">
                      {production.title}
                    </Link>
                  </td>
                  <td>{production.productionDate}</td>
                  <td>{production.location || '-'}</td>
                  <td>
                    <span className={`badge badge-${production.status}`}>
                      {production.status}
                    </span>
                  </td>
                  <td>
                    <span
                      className={`badge ${production.complianceStatus === 'complete' ? 'badge-success' : 'badge-warning'}`}
                    >
                      {production.complianceStatus}
                    </span>
                  </td>
                  <td>
                    <Link
                      to={`/productions/${production.id}`}
                      className="btn btn-small"
                    >
                      View
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
